import React from 'react'

const HeaderText = ({ children }) => {
  return (
    <h2 className='m0 f4'>{children}</h2>
  )
}

export default HeaderText
